import { gaEvent } from '../lib/analytics';

// Amazon "a-smile" mark — Font Awesome Free (CC BY 4.0)
export const AmazonMark = ({ className = 'w-5 h-5', smile = '#FF9900' }) => (
  <svg viewBox="0 0 448 512" className={className} aria-hidden="true">
    <path fill="currentColor" d="M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6z" />
    <path fill={smile} d="M393.2 413c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z" />
  </svg>
);

const track = (placement) => gaEvent('amazon_click', { placement });

// Secondary CTA matching "Add to Cart" exactly (same size, font, shape) in Amazon yellow.
export function AmazonBuyButton({ url, placement, variant = 'block', className = '' }) {
  if (!url) return null;
  const base = 'inline-flex items-center justify-center gap-2 font-bold uppercase bg-[#FF9900] hover:bg-[#E68A00] text-[#0F1111] transition-all duration-200 active:scale-[0.97]';
  const styles = variant === 'pill'
    ? `${base} w-[212px] px-9 py-4 rounded-full tracking-[0.15em] text-sm hover:scale-[1.03] shadow-[0_12px_30px_rgba(255,153,0,0.25)]`
    : `${base} w-full h-14 rounded-lg tracking-widest text-base`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track(placement)}
      className={`${styles} ${className}`}
      data-testid={`amazon-buy-${placement}`}
      aria-label="Also buy at Amazon.in"
    >
      Also buy at
      <AmazonMark className={variant === 'pill' ? 'w-5 h-5' : 'w-6 h-6'} smile="#0F1111" />
    </a>
  );
}

// Small text link for footers / lists.
export function AmazonTextLink({ url, placement, className = '' }) {
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track(placement)}
      className={`inline-flex items-center gap-2 hover:text-white transition-colors ${className}`}
      data-testid={`amazon-link-${placement}`}
    >
      <AmazonMark className="w-4 h-4" />
      Also on Amazon.in
    </a>
  );
}
